import React, { Component, Children, cloneElement } from 'react';

export default (defaultProps = {}) => WrappedComponent => class extends Component {
  static defaultProps = defaultProps;

  dragStartHandler = ({ onDragStart = () => {} }) => event => {
    this.target = event.target;

    event.dataTransfer.clearData();
    event.dataTransfer.setData("text/html", this.target.outerHTML);
    event.dataTransfer.dropEffect = "move";
    event.dataTransfer.effectAllowed = "move";

    onDragStart(event);
  };

  dragOverHandler = ({ onDragOver = () => {} }) => event => {
    event.preventDefault();

    onDragOver(event);
  };

  dropHandler = ({ onDrop = () => {} }) => event => {
    let draggableNode = this.target;

    if (event.currentTarget === draggableNode.nextElementSibling) {
      event.currentTarget.parentNode.insertBefore(event.currentTarget, draggableNode);
    } else {
      event.currentTarget.parentNode.insertBefore(draggableNode, event.currentTarget);
    }

    onDrop(event);
  };

  render () {
    let { children, sortable, draggableChild = sortable?"tr":null, ...otherProps } = this.props;

    if (!draggableChild) {
      return (<WrappedComponent {...otherProps}>{children}</WrappedComponent>);
    }

    return (<WrappedComponent {...otherProps}>
      {Children.map(children, child => {
        if (child.type === draggableChild) {
          return cloneElement(child, {
            draggable: true,
            onDragStart: this.dragStartHandler(child.props),
            onDragOver: this.dragOverHandler(child.props),
            onDrop: this.dropHandler(child.props)
          });
        }
        return child;
      })}
    </WrappedComponent>);
  }
}


// WEBPACK FOOTER //
// ./src/components/hoc/DraggableContainer.js